<template>
  <v-card elevation="0">
    <v-card-title class="bg-purple-darken-2 text-white d-flex align-center">
      <v-icon start>mdi-gift</v-icon>
      Regalar Hospedaje
    </v-card-title>

    <v-card-text class="pt-6">
      <div class="mb-4">
        <span class="text-subtitle-2 text-grey-darken-1">Asignando tiempo gratuito a:</span>
        <h3 class="text-h6 text-primary">{{ company.company }}</h3>
      </div>

      <v-select
        v-model="form.months"
        :items="monthsOptions"
        label="Cantidad de meses"
        variant="outlined"
        prepend-inner-icon="mdi-calendar-month"
        color="purple-darken-2"
      ></v-select>

      <v-alert
        v-if="company.endDate"
        type="info"
        variant="tonal"
        size="small"
        border="start"
        class="mt-2"
      >
        El nuevo periodo se sumará a partir del: 
        <strong>{{ formatDate(company.endDate) }}</strong>
      </v-alert>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn variant="text" color="grey-darken-1" @click="$emit('close')">
        Cancelar
      </v-btn>
      <v-btn 
        color="purple-darken-1" 
        variant="elevated" 
        :loading="loading"
        :disabled="!company.idCompany"
        @click="submitGift"
      >
        Confirmar Regalo
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import apisPayments from '@/apis/apisPayments';

export default {
  name: 'ComponentNewHostFree',
  props: {
    company: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  emits: ['success', 'close'],
  data: () => ({
    loading: false,
    monthsOptions: [
      { title: '1 Mes', value: 1 },
      { title: '3 Meses', value: 3 },
      { title: '6 Meses', value: 6 },
      { title: '1 Año', value: 12 },
    ],
    form: {
      months: 1
    }
  }),
  methods: {
    async submitGift() {
      if (!this.company.idCompany) return;
      
      this.loading = true;
      try {
        // Usamos los IDs que vienen de la empresa seleccionada
        await apisPayments.giftHosting(
          this.company.idCompany, 
          this.company.idUser, 
          this.form.months
        ).then(() => {
          this.$emit('close');
          this.$emit('success');

        });
      } catch (error) {
        console.error("Error al procesar el regalo en Bahiol:", error);
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return '';
      // Formato local para Colombia
      return new Date(date).toLocaleDateString('es-CO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }
}
</script>